import React from 'react';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from "react-router-dom";

import { Footer, Header } from './components';
import { About, Error, Home, Portfolio, Socials, Contact, AlbumPage } from './pages';

export const ROUTES = [
  {
    name: "Home",
    to: '/',
    exact: true,
    component: <Home />,
    showOnTabBar: false
  },
  {
    name: "Home-Reroute",
    to: '/home',
    exact: true,
    component: <Navigate to="/" />,
    showOnTabBar: false
  },
  {
    name: "Album",
    to: '/album/:slug',
    component: <AlbumPage />,
    showOnTabBar: false
  },
  {
    name: "Error",
    to: '*',
    exact: false,
    component: <Error />,
    showOnTabBar: false
  }
]

const Content = () => {
  return (
    <Router>
      <Routes>
        {ROUTES.map(({exact, to, component}, i) => (
          <Route exact={exact} path={to} element={component} />
        ))}
      </Routes>
    </Router>
  );
}

export default Content;